import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BroadcasterService } from '../broadcaster/broadcaster.service';

export enum DCEventType {
    OPEN = 'OPEN',
    CLOSE = 'CLOSE'
}

@Injectable()
export class DynamicComponentBroadcasterService {
    constructor(private _broadcasterService: BroadcasterService) {}

    public fire(key: DCEventType, data?: any, parameter = 'default') {
        this._broadcasterService.broadcast(`dcb_${key}_${parameter}`, data);
    }

    public onOpen(parameter = 'default'): Observable<any> {
        return this._broadcasterService.on<any>(`dcb_${DCEventType.OPEN}_${parameter}`);
    }

    public onClose(parameter = 'default'): Observable<any> {
        return this._broadcasterService.on<any>(`dcb_${DCEventType.CLOSE}_${parameter}`);
    }
}
